module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popper', {
    attrs: {
      "trigger": "hover",
      "options": {
        placement: 'bottom',
        modifiers: {
          offset: {
            offset: '0,10px'
          }
        }
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alt),
      expression: "alt"
    }],
    staticClass: "popper"
  }, [_vm._v("\n    " + _vm._s(_vm.alt) + "\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn p-0",
    attrs: {
      "slot": "reference"
    },
    on: {
      "mouseover": function($event) {
        _vm.hover = true
      },
      "mouseout": function($event) {
        _vm.hover = false
      }
    },
    slot: "reference"
  }, [(_vm.hover) ? _c('img', {
    attrs: {
      "src": _vm.imgOn
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.imgOff
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-502d84c3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Teacher/IconButton.vue
// module id = 730
// module chunks = 1